//#region types
import { IconDefinitionConstants } from "utils/constants";
import { DialogEnums } from "models/enums";
import { DialogProps } from "models/propTypes/dialogPropTypes";
import { TranslationKeys } from "translations";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

function useSendInvoiceDocumentationQueryDialog() {
  const getSendInvoiceDocumentationQueryDialog = (onSubmitSuccess?: () => Promise<void>): DialogProps => {
    return {
      isOpen: false,
      title: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.TimeReporting.InvoiceDocumentationNotAttestedHeader
      ),
      dialogType: DialogEnums.DialogType.Message,
      titleIcon: IconDefinitionConstants.WQuestionCircle,
      children: LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.TimeReporting.InvoiceDocumentationNotAttestedQuery
      ),
      maxWidth: "sm",
      actions: [
        {
          text: "OK",
          onClick: onSubmitSuccess,
        },
      ],
    };
  };

  return getSendInvoiceDocumentationQueryDialog;
}

export default useSendInvoiceDocumentationQueryDialog;
